import { formatDateYyyyMmDd } from '../../global/utils/date/date-utils-yyyy-mm-dd'

export function getMissionCapableData(
  fromDate: Date,
  toDate: Date,
  locationObjectId?: string,
  csv?: boolean,
) {
  const fromParam = formatDateYyyyMmDd(fromDate)
  const toParam = formatDateYyyyMmDd(toDate)
  let url = `${process.env.REACT_APP_ORIGIN}/reportsV2/mission-capable-report?fromDate=${encodeURIComponent(fromParam)}&toDate=${encodeURIComponent(toParam)}`
  if (locationObjectId) {
    url += `&locationObjectId=${encodeURIComponent(locationObjectId)}`
  }
  if (csv) {
    url += `&csv=true`
  }
  return {
    method: 'GET',
    url,
  }
}
